<div class="flex-column h-100 bg-white">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@gasWarningCenterConfiguration.selectGasWarningCenter.dockingStations.header"
      data-testid="gasWarningCenterConfiguration.selectGasWarningCenter.dockingStations.header"
    >
      Dockingstations auswählen
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
    <odx-inline-message [variant]="isSelectionValid() ? 'default' : 'danger'">{{ infoMessage() }}</odx-inline-message>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (filteredDockingStations$ | async; as dockingStations) {
      @if (dockingStations.length > 0) {
        <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
          @for (dockingStation of dockingStations; track dockingStation.id) {
            <app-gas-warning-center-card
              class="overflow-hidden"
              [gasWarningCenterData]="dockingStation"
              selectionMode="multi"
              [showCosts]="project().showCostFlag"
              [quantity]="getSelectedQuantity(dockingStation)"
              [preselectedQuantity]="getPreselectedQuantity(dockingStation)"
              [type]="type()"
              (quantityChanged$)="updateSelectedDockingStations($event, dockingStation)"
            >
            </app-gas-warning-center-card>
          }
        </div>
      } @else {
        <app-refresh-products-hint
          dataType="Dockingstations"
          i18n-dataType="@@global.dockingStations"
        ></app-refresh-products-hint>
      }
    }
  </odx-content-box>
</div>
